export default __webpack_public_path__ + "img/5df33b7cdde0a38f6c461cf62aa8f33f.png";